import React from 'react';
import { ADSENSE_CLIENT, ADSENSE_SLOT, IS_DEBUG } from '../utils/env';

interface AdSlotProps {
  slot?: string;
  style?: React.CSSProperties;
}

const AdSlot: React.FC<AdSlotProps> = ({ slot, style }) => {
  React.useEffect(() => {
    if (!window || !(window as any).adsbygoogle) return;
    try {
      (window as any).adsbygoogle.push({});
    } catch {}
  }, []);

  if (!ADSENSE_CLIENT) {
    // Show a visible placeholder in debug so you can see layout
    if (IS_DEBUG) {
      return (
        <div
          style={{
            display: 'block',
            textAlign: 'center',
            minHeight: 60,
            border: '2px dashed rgba(33,150,243,0.8)',
            borderRadius: 8,
            color: '#1565c0',
            background: 'rgba(33,150,243,0.06)',
            padding: 8,
          }}
        >
          Ad placeholder (configure REACT_APP_ADSENSE_CLIENT)
        </div>
      );
    }
    return null;
  }

  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block', textAlign: 'center', ...(style || {}) }}
      data-ad-client={ADSENSE_CLIENT}
      data-ad-slot={slot || ADSENSE_SLOT || ''}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
};

export default AdSlot;


